import { getLocale } from "../runtime";

const sv_loading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Laddar...`
};

const loading = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_loading(inputs)
	return "loading";
};

export { loading as "loading" };